/**
 * Pixelgipfel — Werkstatt-Liveticker (geteilt: Startseite + Werkstatt-Seite).
 *
 * Modell "Auftrags-Fenster": Jeder Auftrag im Pool hat ein festes, gestaffeltes
 * Zeitfenster über einen Zyklus aus ARBEITSTAGEN (z. B. Di–Fr). An einem
 * gegebenen Arbeitstag sind die Auftraege "aktiv", deren Fenster ihn enthaelt.
 * Der Fortschritt "Tag x/y" zaehlt nur an Arbeitstagen hoch, ueber Reloads und
 * fuer alle Besucher gleich (rein aus dem Datum berechnet, kein Backend).
 * Wie viele gleichzeitig laufen, schwankt natuerlich (variierend).
 *
 * Offen (Oeffnungszeiten, Europe/Zurich): grüner Puls + "Tag x/y".
 * Geschlossen: "Geplant für nächste Woche" mit "ab <Wochentag>".
 *
 * Markup-Hooks (klassen-agnostisch, funktioniert fuer beide Sektionen):
 *   [data-pg-ticker] ODER [data-pg-live]  -> Container mit data-pg-config
 *   [data-pg-job][data-pg-duration]       -> Auftrags-Pill
 *   [data-pg-job-detail]                  -> Text-Span fuer den Suffix
 *   [data-pg-ticker-label] / [data-pg-live-label] -> Label-Span
 */
(function () {
  'use strict';

  var EPOCH = Date.UTC(2020, 0, 1); // 2020-01-01, ein Mittwoch (UTC-Wochentag 3)
  var EPOCH_WD = 3;
  var DAY_NAMES = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var DAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function zurichNow() {
    var opts = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' };
    var parts;
    try {
      opts.timeZone = 'Europe/Zurich';
      parts = new Intl.DateTimeFormat('en-GB', opts).formatToParts(new Date());
    } catch (e) {
      delete opts.timeZone;
      parts = new Intl.DateTimeFormat('en-GB', opts).formatToParts(new Date());
    }
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      wd: DAY_MAP[o.weekday],
      hour: parseInt(o.hour, 10),
      y: parseInt(o.year, 10),
      mo: parseInt(o.month, 10),
      da: parseInt(o.day, 10)
    };
  }

  // Anzahl Arbeitstage (Wochentage in openDays) von EPOCH bis Kalendertag-Index N, inklusive.
  function workdayCount(calDayIndex, openDays) {
    if (calDayIndex < 0) calDayIndex = 0;
    var total = calDayIndex + 1; // inklusive heute
    var fullWeeks = Math.floor(total / 7);
    var rem = total % 7;
    var count = fullWeeks * openDays.length;
    for (var k = 0; k < rem; k++) {
      var wd = (EPOCH_WD + k) % 7;
      if (openDays.indexOf(wd) !== -1) count++;
    }
    return count;
  }

  // Naechster offener Wochentag ab Kalendertag-Index (0 = suche ab morgen)
  function nextOpenWeekday(calDayIndex, openDays) {
    for (var i = 1; i <= 7; i++) {
      var wd = (EPOCH_WD + calDayIndex + i) % 7;
      if (openDays.indexOf(wd) !== -1) return wd;
    }
    return openDays[0];
  }

  // mulberry32 fuer die feste (nicht tagesabhaengige) Offset-Zuweisung
  function makeRnd(seed) {
    var s = seed | 0;
    return function () {
      s = (s + 0x6D2B79F5) | 0;
      var v = Math.imul(s ^ (s >>> 15), 1 | s);
      v = (v + Math.imul(v ^ (v >>> 7), 61 | v)) ^ v;
      return ((v ^ (v >>> 14)) >>> 0) / 4294967296;
    };
  }

  function initTicker(root) {
    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-pg-config')); } catch (e) { return; }
    var jobs = Array.prototype.slice.call(root.querySelectorAll('[data-pg-job]'));
    if (!jobs.length) return;

    var openDays = (cfg.days && cfg.days.length) ? cfg.days : [2, 3, 4, 5];
    var minJobs = Math.max(1, cfg.min || 2);
    var maxJobs = Math.max(minJobs, cfg.max || 5);

    var now = zurichNow();
    var isOpen = openDays.indexOf(now.wd) !== -1 && now.hour >= cfg.from && now.hour < cfg.to;

    var calIndex = Math.floor((Date.UTC(now.y, now.mo - 1, now.da) - EPOCH) / 86400000);
    // Arbeitstag-"Uhr": offen -> heutiger Arbeitstag; geschlossen -> naechster Arbeitstag
    var wDay = workdayCount(calIndex, openDays);
    if (!isOpen) wDay = wDay + 1;

    var n = jobs.length;
    var durations = jobs.map(function (j) {
      return Math.max(1, parseInt(j.getAttribute('data-pg-duration'), 10) || 1);
    });
    var sumDur = durations.reduce(function (a, b) { return a + b; }, 0);
    var maxDur = Math.max.apply(null, durations);

    // Zykluslaenge so, dass im Schnitt ~ (min+max)/2 Auftraege gleichzeitig laufen
    var target = (minJobs + maxJobs) / 2;
    var period = Math.max(maxDur, Math.round(sumDur / target));

    // Feste, gleichmaessig verteilte + leicht gemischte Offsets (konstanter Seed)
    var order = jobs.map(function (_, i) { return i; });
    var rnd = makeRnd(0x9E3779B1);
    for (var i = order.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1));
      var t = order[i]; order[i] = order[j]; order[j] = t;
    }
    var offset = [];
    order.forEach(function (jobIdx, pos) {
      offset[jobIdx] = Math.floor(pos * period / n);
    });

    // Aktive Auftraege am Arbeitstag wDay bestimmen
    var active = [];
    for (var k = 0; k < n; k++) {
      var phase = (((wDay - offset[k]) % period) + period) % period;
      if (phase < durations[k]) {
        active.push({ idx: k, day: phase + 1, total: durations[k], phase: phase });
      }
    }

    // Sicherheitsnetz: zu wenige -> die "am frischesten gestarteten" auffuellen
    if (active.length < minJobs) {
      var byFresh = jobs.map(function (_, k) {
        var phase = (((wDay - offset[k]) % period) + period) % period;
        return { idx: k, phase: phase, total: durations[k] };
      }).sort(function (a, b) { return a.phase - b.phase; });
      active = [];
      for (var m = 0; m < Math.min(minJobs, n); m++) {
        var it = byFresh[m];
        active.push({ idx: it.idx, day: (it.phase % it.total) + 1, total: it.total, phase: it.phase });
      }
    }
    // zu viele -> laengste (am meisten Fortschritt sichtbar) behalten
    if (active.length > maxJobs) {
      active.sort(function (a, b) { return b.total - a.total; });
      active = active.slice(0, maxJobs);
    }

    // Anzeige lang -> kurz
    active.sort(function (a, b) { return b.total - a.total; });

    var abWeekday = DAY_NAMES[nextOpenWeekday(calIndex, openDays)];

    // Container = gemeinsamer Eltern der Pills (bar beim Ticker, live-div bei der Werkstatt-Seite)
    var container = jobs[0].parentNode;
    var anchor = container.querySelector('[data-pg-ticker-link]');

    jobs.forEach(function (pill) { pill.hidden = true; });
    active.forEach(function (a) {
      var pill = jobs[a.idx];
      var detail = pill.querySelector('[data-pg-job-detail]');
      if (detail) {
        var base = detail.getAttribute('data-pg-base');
        if (base === null) {
          base = detail.textContent.trim();
          detail.setAttribute('data-pg-base', base);
        }
        var suffix = isOpen ? ('Tag ' + a.day + '/' + a.total) : ('ab ' + abWeekday);
        detail.textContent = base ? base + ' · ' + suffix : suffix;
      }
      if (anchor) { container.insertBefore(pill, anchor); } else { container.appendChild(pill); }
      pill.hidden = false;
    });

    var label = root.querySelector('[data-pg-ticker-label], [data-pg-live-label]');
    if (label) label.textContent = isOpen ? (cfg.labelOpen || '') : (cfg.labelClosed || '');
    container.setAttribute('data-pg-mode', isOpen ? 'open' : 'closed');
  }

  function wire() {
    document.querySelectorAll('[data-pg-ticker], [data-pg-live]').forEach(function (root) {
      if (root.dataset.pgTickerWired === '1') return;
      root.dataset.pgTickerWired = '1';
      initTicker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', wire);
})();
